import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const WeldDetailItemContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  mx: { sm: '500' },
  mt: { sm: '500' },
})`
  ${({ theme }) => css`
    height: calc(100vh - 170px);
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[400]};
    overflow-y: hidden;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px, rgb(0 0 0 / 12%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px;
  `}
`;
